import PropertyEditContent from './PropertyEditContent'
import PropertyContextProvider from '../../../context/property-context'

function EditPropertyContextWrapper(props) {
    return (
        <PropertyContextProvider>
            <PropertyEditContent/>
        </PropertyContextProvider>
    )
}

export default EditPropertyContextWrapper 